import { useContext as r } from "react";
import { FullscreenContext as n } from "./index.es143.js";
const t = () => {
  const e = r(n);
  return e || console.warn("Missing Fullscreen Provider"), e;
};
export {
  t as useFullscreen
};
//# sourceMappingURL=index.es144.js.map
